import React, {useState} from 'react';
import { Form } from 'react-final-form';
import { Row, Col, ButtonToolbar, Button } from 'reactstrap';
import formValidation from "@/shared/validation/editprogramuser";
import axios from 'axios';
import { fetchUser, fetchRoles, fetchUserProgramRoles } from "@/shared/apiHelper"
import {unpatchSelect, labelizeNamedData, buildIdArray} from '@/shared/helpers'
import {useDispatch, flashSuccess, flashError} from "@/shared/components/flash"
import ProgramUserFormFields from './ProgramUserFormFields'
import arrayMutators from "final-form-arrays"
import getUnitNumbers from '@/service/program/getUnitNumbers'
import {getPositionLevels} from '@/service/program/position'
import { isObject } from '../../../../shared/helpers';

let config = {
  roles:[],
  roleInput: 'checkbox',
  roleField: 'roles',
  rolePlaceholder: 'Select Role',
  roleDisable: false,
  isProgram: false,
  unitNumberField: 'unit_number',
  unitNumberOptions: [],
  positionLevelField: 'position_level',
  positionLevelOptions: []
}

const getBirthday = (user) => {
    if(user.dob){
        let dateParts = user.dob.split('-');
        let month = dateParts[1];
        let day = dateParts[2];
        user.month = month;
        user.day = day;
    }
    return user;
}

const setBirthday = (values) => {
    if(values.day && values.month){
        let month = isObject(values.month)? values.month.value : values.month
        let day = isObject(values.day)? values.day.value : values.day
        values.dob = formatDate(month, day)
    }
    return values;
}

const formatDate = (month, day) => {
  let year = String(1).padStart(4, '0');
  month = String(month).padStart(2, '0');
  day = String(day).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

const EditProgramUserForm = ({organization, program, userid, toggle, setTrigger}) => {
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)
    const [roles, setRoles] = useState(null)
    const [programRoles, setProgramRoles] = useState(null)
    const [unitNumberOptions, setUnitNumberOptions] = useState(config.unitNumberOptions);
    let [user, setUser] = useState(null)
    const [positionLevelOptions, setPositionLevelOptions] = useState(config.positionLevelOptions);

    React.useEffect( () => {
        getRoles(program.organization_id);
        fetchUser(program.organization_id, userid, program.id)
        .then( data => {
            data.avatar = null;
            setUser(data);
            setLoading(false)
        })

        fetchUserProgramRoles(program.organization_id, userid, program.id)
        .then( _roles => {
            // console.log(_roles)
            // const _roles = extractRolesFromProgramPermissions(_permissions, program.id);
            setProgramRoles(buildIdArray(_roles))
        })
    }, [program])

    React.useEffect( () => {
        
    }, [user])

    React.useEffect(() => {
      if (organization?.id && program?.id && program?.uses_units) {
        getUnitNumbers(organization.id, program.id, "assignable=1").then( res => {
          setUnitNumberOptions(labelizeNamedData(res));
        })
      }
    }, [organization, program]);


    const getRoles = ( organizationId ) => {
        setLoading(true)
        fetchRoles( organizationId, 1 )
        .then( data => {
            if( config.roleInput === 'select')    {
                data = labelizeNamedData(data);
            }
            
            setRoles(data);
            setLoading(false)
        })
    }

    React.useEffect(() => {
      if (
        organization?.id &&
        program?.id &&
        (program?.use_budget_cascading > 0 ||
          program?.use_cascading_approvals > 0)
      ) {
        getPositionLevels(organization.id, program.id, "assignable=1").then(
          (res) => {
            setPositionLevelOptions(
              labelizeNamedData(res, ["id", "title"])
            );
          }
        );
      }
    }, [organization, program]);

   
  
    const onSubmit = values => {
        if (values.award_level && values.award_level.value) {
            values.award_level = values.award_level.value;
        }

        if( config.roleInput === 'select')    {
            values = unpatchSelect(values, [config.roleField])
        }
        if( typeof values.unit_number === 'object') {
          values = unpatchSelect(values, [config.unitNumberField])
        }
        if( typeof values.position_level === 'object') {
            values = unpatchSelect(values, [config.positionLevelField])
          }
        // setLoading(true)
        values = setBirthday(values)

        const isLocked = values.is_locked ? 1 : 0;
        // clear reason when unlocking
        const lockReason = isLocked ? values.is_locked_reason : null;

        let userData = {
          first_name: values.first_name,
          last_name: values.last_name,
          roles: values.roles,
          user_status_id: values.user_status_id,
          email: values.email,
          phone: values.phone || null,
          country_id: values.country_id.value,
          award_level: values.award_level,
          work_anniversary: values.work_anniversary,
          dob: values.dob,
          division: values.division,
          employee_number: values.employee_number,
          supervisor_employee_number: values.supervisor_employee_number,
          password: values.password,
          password_confirmation: values.password_confirmation,
          is_organization_admin: values.is_organization_admin,
          unit_number: values.unit_number,
          position_level: values.position_level,
          is_locked: isLocked,
          is_locked_reason: lockReason,
          force_password_reset: values.force_password_reset ? 1 : 0,
      }
      axios.put(`/organization/${program.organization_id}/program/${program.id}/user/${userid}`, userData)
        .then( (res) => {
            // console.log(res)
            if(res.status == 200)  {
                toggle()
                setTrigger( Math.floor(Date.now() / 1000) )
                // dispatch(sendFlashMessage(, 'alert-success'))
                flashSuccess(dispatch, "User Updated successfully!")
            }
        })
        .catch( error => {
            flashError(dispatch, error.response.data)
            setLoading(false)
        })
    }

    const validate = async(values) => {
        // console.log(values)
        let v1 = await formValidation.validateForm(values)

        v1 = v1 ? v1 : {}

        // if( !values.password )  {
        //     v1.password = 'Password is required'
        // }
        // if( !values.password_confirmation )  {
        //     v1.password_confirmation = 'Confrim Password is required'
        // } else 
        
        if( ( values.password || values.password_confirmation ) && values.password !== values.password_confirmation )  {
            v1.password_confirmation = 'Passwords do not match'
        }
        if (values.is_locked && !values.is_locked_reason) {
            v1.is_locked_reason = "Reason for locking user account is required";
        }
        // console.log(v1)
        return v1
    }

    if( !roles ) return 'Loading...'

    config = {...config, ...{roles}}
    if(user && !user.role_id){
        delete(user.role_id);
    }
    
    user = {...user, ...{roles: programRoles}}
    // console.log(user.roles)
    user.user_status_id = String(user.user_status_id ? user.user_status_id : "")
    user.unit_number = String(user?.unitNumber?.id ? user.unitNumber.id : "")
    user.position_level = String(user?.positionLevel?.id ? user.positionLevel.id : "")
    user.is_organization_admin = user.isAdmin
    // user.unit_number = "2"
    // // console.log(user.user_status_id)
    // console.log("user.unit_number")
    // console.log(typeof user.unit_number)
    user = getBirthday(user)
    user.is_locked = user.is_locked ? 1 : 0;
    user.is_locked_reason = user.is_locked_reason || "";

    return (
    <Form
        onSubmit={onSubmit}
        validate={validate}
        initialValues={user}
        mutators={{
            ...arrayMutators
        }}
    >
    {({ handleSubmit, form, submitting, pristine, values }) => {
    return (
        <form className="form" onSubmit={handleSubmit}>
            <Row className='w100'>
                <Col md="6" lg="6" xl="6">
                    <h3 className="mb-4">Edit User</h3>
                </Col>
                <Col md="6" lg="6" xl="6" className='text-right'>
                    <ButtonToolbar className="modal__footer flex justify-content-right w100">
                        <Button outline color="primary" className="mr-3" onClick={toggle}>Close</Button>{' '}
                        <Button type="submit" disabled={loading} className="btn btn-primary" color="#ffffff">Save</Button>
                    </ButtonToolbar>
                </Col>
            </Row>
            <ProgramUserFormFields config={{...config, ...{
              unitNumberOptions }, ...{positionLevelOptions
            }}} form={form} submitting={submitting} pristine={pristine} values={values} program={program}/>
        </form>
    )}}
    </Form>
)}

export default EditProgramUserForm;